import { Component, Input } from '@angular/core';
import { CardType } from '../../../enums/card-type.enum';
import { Navigation } from '../../../models/navigation.model';

@Component({
  selector: 'lns-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  @Input() cardType: CardType = CardType.White;
  @Input() navigations: Navigation[] = [];

  cardTypes = CardType;
}
